import React, { TextareaHTMLAttributes, forwardRef } from "react";
// 1. Import the new CSS file
import "./textArea.module.css";

// UI props interface remains the same
export interface TextAreaUIProps {
    /**
     * Error textarea
     */
    uiError?: boolean;
    /**
     * Disabled textarea
     */
    uiDisabled?: boolean;
    /**
     * Resizable textarea
     * @default false
     */
    uiResize?: boolean;
}

// Full props type
export type TextAreaProps = TextareaHTMLAttributes<HTMLTextAreaElement> &
    TextAreaUIProps;

/**
 * Simple textarea with generic styling
 */
const TextArea = forwardRef<HTMLTextAreaElement, TextAreaProps>(
    (props, ref) => {
        const {
            // Destructure UI props
            uiError,
            uiDisabled,
            uiResize = false, // Set default value from defaultProps

            // Destructure standard props
            className,
            ...other
        } = props;

        // 2. Build the list of CSS classes
        const classNames = [
            "text-area", // Base class
            uiError ? "text-area-error" : "",
            !uiResize ? "text-area-no-resize" : "",
            className, // Pass through any parent class
        ]
            .filter(Boolean)
            .join(" ");

        // 3. Render the standard <textarea> element
        return (
            <textarea
                ref={ref}
                className={classNames}
                disabled={uiDisabled} // Use the native disabled attribute
                {...other}
            />
        );
    }
);

TextArea.displayName = "TextArea";

export default TextArea;